export var BluetoothDeviceType;
(function (BluetoothDeviceType) {
    BluetoothDeviceType["Unknown"] = "unknown";
    BluetoothDeviceType["Classic"] = "classic";
    BluetoothDeviceType["Le"] = "le";
    BluetoothDeviceType["Dual"] = "dual";
})(BluetoothDeviceType || (BluetoothDeviceType = {}));
//# sourceMappingURL=definitions.js.map